import React, { useEffect, useState } from "react";
import { Topbar, Alert } from "@components";
import { useNavigate } from "react-router-dom";
import {
  // Avatar,
  // Badge,
  InputLabel,
  Input,
  FileInput,
  RootContainer,
  Button,
  ProfileCard,
  ProfileImg,
} from "./EditProfile.style";
import { CameraFilled } from "@assets";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useDispatch, useSelector } from "react-redux";
import { api } from "@api";
import { saveUser } from "@redux/auth/authSlice";
import { openAlert } from "@redux/app/appSlice";
import { localStorage } from "@utils";
import { useTranslation } from "react-i18next";

const EditProfileInput = ({
  label,
  placeholder,
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <>
      <InputLabel>{label}</InputLabel>
      <Input
        placeholder={placeholder}
        size="large"
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </>
  );
};

const EditProfile = () => {
  const { t } = useTranslation();
  const [image, setImage] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [data, setData] = useState({
    name: "",
    phone: "",
    email: "",
  });
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    setData({
      name: user.name,
      phone: user.phone,
      email: user.email,
    });
  }, [user]);

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.PROFILE}`);
  };

  const handleUpdate = () => {
    setLoading(true);
    api
      .updateProfile({
        name: data.name,
      })
      .then(({ user }) => {
        setLoading(false);
        showAlert({
          message: t("common.updateSuccessMessage"),
          successCallback: goBack,
        });
        // save token and user to redux
        dispatch(saveUser(user));

        // save token and user to localstorage
        localStorage.setUser(user);
      })
      .catch((errorMsg) => {
        setLoading(false);
        showAlert({
          message: errorMsg,
          isError: true,
        });
      });
  };

  const handleImageUpload = (event) => {
    setImageLoading(true);
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      setImage(reader.result);
    };

    reader.readAsDataURL(file);
    api
      .getPresignedUrl({
        upload_type: "profile-images",
        content_type: file.type,
      })
      .then(({ presigned_url }) => {
        api
          .uploadMedia({
            url: presigned_url.url,
            fields: presigned_url.fields,
            file,
          })
          .then(() => {
            api
              .updateProfile({
                name: user.name,
                image: `${presigned_url.url}${presigned_url.fields.Key}`,
              })
              .then(({ user }) => {
                setImageLoading(false);
                showAlert({
                  message: t("common.updateSuccessMessage"),
                });
                // save token and user to redux
                dispatch(saveUser(user));

                // save token and user to localstorage
                localStorage.setUser(user);
              })
              .catch((errorMsg) => {
                handleImageUploadFailed(errorMsg);
              });
          })
          .catch((errorMsg) => {
            handleImageUploadFailed(errorMsg);
          });
      })
      .catch((errorMsg) => {
        handleImageUploadFailed(errorMsg);
      });
  };

  const handleImageUploadFailed = (message) => {
    setImage(null);
    setImageLoading(false);
    showAlert({
      message,
      isError: true,
    });
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  let profileSrc = null;
  if (image) {
    profileSrc = image;
  } else if (user.image) {
    profileSrc = user.image;
  }

  const Profile = ({ imageUrl }) => {
    return (
      <ProfileCard>
        <ProfileImg src={imageUrl} alt="Profile">
          {user.name[0]}
        </ProfileImg>
      </ProfileCard>
    );
  };

  return (
    <>
      <Topbar title={t("profile.profileEditTitle")} goBack={goBack} />
      <RootContainer>
        <div style={{ position: "relative" }}>
          {/* <Avatar size={70} src={profileSrc} /> */}
          <Profile imageUrl={profileSrc} />
          <div
            style={{
              position: "absolute",
              bottom: -15,
              left: "37%",
              width: "26px",
              height: "26px",
              // backgroundColor: "#fff",
              // borderRadius: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {imageLoading ? (
              <Spin indicator={<LoadingOutlined spin />} />
            ) : (
              <>
                <FileInput
                  id="file-upload"
                  type="file"
                  onChange={handleImageUpload}
                  accept="image/*"
                />
                <label htmlFor="file-upload" style={{}}>
                  <CameraFilled style={{ cursor: "pointer" }} />
                </label>
              </>
            )}
          </div>
        </div>
        {/* <Badge count={`Lv-${user.level}`} /> */}
        <EditProfileInput
          label={t("profile.name")}
          placeholder={t("profile.enterName")}
          value={data.name}
          onChange={(e) =>
            setData((prev) => ({ ...prev, name: e.target.value }))
          }
        />
        <EditProfileInput
          label={data.phone ? t("profile.phone") : t("profile.email")}
          value={data.phone || data.email}
          disabled={true}
        />
        <Button
          type="primary"
          size="large"
          onClick={handleUpdate}
          loading={loading}
        >
          {t("common.save")}
        </Button>
      </RootContainer>
      <Alert />
    </>
  );
};

export default EditProfile;
